<template>
    <div class="alert-list-container">
        <el-dialog :title="dialogTitle" :visible.sync="isShow1" width="64%" append-to-body @close="closeWindow">
            <!-- 查询区域 -->
            <!-- 查询区域 -->
            <el-form :inline="true" :model="searchForm" size="mini" label-width="100px" class="demo-form-inline">
                <el-form-item label="设备类型:">
                    <el-select v-model="searchForm.deviceType" placeholder="请选择" clearable style="width: 150px">
                        <el-option v-for="(item, index) in typeList" :key="index" :label="item.dictLabel"
                            :value="item.dictLabel"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="设备编码:">
                    <el-input v-model="searchForm.equipmentNumber" placeholder="请输入" clearable style="width: 160px" />
                </el-form-item>

                <el-form-item label="告警类型:">
                    <el-select v-model="searchForm.type" placeholder="请选择" clearable style="width: 150px">
                        <el-option :label="v.label" :value="v.value" v-for="(v, i) in typeOptions" :key="i" />
                    </el-select>
                </el-form-item>

                <el-form-item label="告警时间:">
                    <el-date-picker v-model="timeValue" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getTableData">查询</el-button>
                    <el-button type="info" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
            <!-- 表格区域 -->
            <el-table :data="tableData" border highlight-current-row style="width: 100%; margin-top: 10px"
                :header-cell-style="{ background: '#f8fafa' }">
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="deviceType" label="设备类型" align="center" />
                <el-table-column prop="equipmentName" label="设备名称" align="center" />
                <el-table-column prop="equipmentNumber" label="设备编码" align="center" />
                <el-table-column prop="title" label="告警标题" align="center" />
                <el-table-column prop="typeStr" label="告警类型" align="center">
                    <template slot-scope='scope'>
                        <span>{{ getTypeLabel(scope.row.type) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="告警内容" align="center" show-overflow-tooltip />
                <el-table-column prop="alarmTime" label="告警时间" align="center" width="180" />
                <!-- <el-table-column prop="statusText" label="处理状态" align="center" width="100">
                    <template #default="scope">
                        <el-tag :type="scope.row.status === 'handled' ? 'success' : 'warning'">
                            {{ scope.row.statusText }}
                        </el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column align='center' label='操作' fixed='right'>
                    <template slot-scope='scope'>
                        <button class='tabBtn' @click="showDialog('查看', scope.row)">查看</button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页功能 -->
            <el-pagination :page-size='pageConfig.pageSize' layout='total, prev, pager, next, jumper'
                @current-change='handleCurrentChange' :total='pageConfig.total'></el-pagination>
            <div class="action-buttons">
                <el-button @click="closeWindow">取 消</el-button>
            </div>
        </el-dialog>
        <seeInfo title='告警详情' :isDialog="isDialog" :detailInfo="detailInfo" @closeDialog="closeDialog"></seeInfo>
    </div>
</template>

<script>
import { post } from '@/api/requrestHttp'
import seeInfo from './seeInfo.vue';
export default {
    components: { seeInfo },
    props: ['dialogTitle', 'isShow1', 'customerId'],
    name: 'AlertList',
    data() {
        return {
            searchForm: {
            },
            tableData: [],
            pageConfig: {
                pageNo: 1,
                pageSize: 10,
                total: 0
            },
            isDialog: false,
            detailInfo: {},
            typeOptions: [
                { label: '呼吸率', value: '0' },
                { label: '心率', value: '1' },
                { label: '离床', value: '2' },
                { label: '设备上线', value: '3' },
                { label: '设备下线', value: '4' },
                { label: '跌倒预警', value: '9' },
                { label: '无人预警', value: '10' },
                { label: '驻留预警', value: '11' }
            ],
            timeValue: '',
            typeList: []
        }
    },
    watch:{
      isShow1: {
        handler(newVal) {
            if (newVal) {
            this.getTableData()
            }
        },
      immediate: true 
    }
    },
    methods: {
        async getTypeList() {
            let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "equipment_type",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.typeList = res.rows
                        }
                    }
                })
        },
        getTypeLabel(type) {
            if (type === undefined || type === null) return '未知类型';
            const option = this.typeOptions.find(item => item.value === type.toString());
            return option ? option.label : '未知类型';
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getTableData()
        },
        handleReset() {
            this.searchForm = {}
            this.timeValue = ''
        },
        //获取列表数据
        async getTableData() {
            // this.searchlist.isEquCustomer=1
            this.searchForm.startTime = this.timeValue[0]
            this.searchForm.endTime = this.timeValue[1]
            const { content } = await post('/ypt/admin/equipment/alarm/findList', {
                ...this.searchForm,
                ...this.pageConfig,
                customerId: this.customerId
            })
           if(content !=null){
                this.tableData = content.list || []
                this.pageConfig.total = content.count
            }else{
                this.tableData = []
                this.pageConfig.total = 0
            }
        },
        async showDialog(type, row) {
            this.isDialog = true
            let url = '/ypt/admin/equipment/alarm/getById'
            let res = await post(url, { id: row.id })
            if (res.content != null) {
                this.detailInfo = res.content || {}
            }
        },
        closeDialog() {
            this.detailInfo = {}
            this.isDialog = false
        },
        closeWindow() {
         this.$emit('dialogClose')
       }
    },
    mounted() {
      //  this.getTableData()
    }
}
</script>

<style scoped>
.alert-list-container {
    padding: 15px;
    background-color: #fff;
}

.tabBtn {
    font-size: 13px;
    margin: 0 3px;
}
.action-buttons {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
    text-align: right;
}

.cancel-btn {
    margin-right: 10px;
}
</style>